import React, { useState } from 'react';
import { Box } from "@mui/material"
import LoginComp from "./login";
import { LoginUser } from '../../models/user';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import AppUtils from '../../apputils';
import { useNavigate } from 'react-router-dom';


const Login = () => {

  const [txtLoginUserName, settxtLoginUserName] = useState('');
  const [txtLoginUserNameErr, settxtLoginUserNameErr] = useState('');
  const [txtLoginPassword, settxtLoginPassword] = useState('');
  const [txtLoginPasswordErr, settxtLoginPasswordErr] = useState('');
  const [login, setLogin] = useState(false);
  const [loginData, setLoginData] = useState({});
  const [alertMsg, setAlertMsg] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const userData = useUserStore;
  const navigate = useNavigate();

  if (!window.location.href.includes('login')) {
    window.history.pushState('login', 'Login', 'login');
    window.history.replaceState('login', 'Login', 'login');
  }

  const state = {
    txtLoginUserName: txtLoginUserName,
    txtLoginUserNameErr: txtLoginUserNameErr,
    txtLoginPassword: txtLoginPassword,
    txtLoginPasswordErr: txtLoginPasswordErr,
    login: login,
    alertMsg: alertMsg,
    showAlert: showAlert,
    alertType: alertType
  }

  const HandleInputs = (e, name) => {
    let value = e.target.value;

    if (name == 'txtLoginUserName') {
      settxtLoginUserName(value);
    }
    else if (name == 'txtLoginPassword') {
      settxtLoginPassword(value);
    }
  }

  const SignIn = () => {
    if (txtLoginUserName.trim() == '') {
      settxtLoginUserNameErr('Invalid User Name');
      return false;
    }
    else {
      settxtLoginUserNameErr('');
    }
    if (txtLoginPassword.trim() == '') {
      settxtLoginPasswordErr('Invalid Password');
      return false;
    }
    else {
      settxtLoginPasswordErr('');
    }
    setLoginData({
      txtLoginEmail: txtLoginUserName,
      txtLoginPassword: txtLoginPassword,
      txtLoginFrom: 'GPT'
    })
    // console.log(loginData);
    setLogin(true);
  }

  const handleCloseAlert = () => {
    setShowAlert(false);
    setAlertMsg('');
    setAlertType('');
  }

  const Handleuserloginresponseonse = (res) => {

    console.log(res);

    if (res != false) {
      if (res.data.userloginresponse.rows.msg !== undefined && res.data.userloginresponse.rows.msg !== '') {
        setShowAlert(true);
        setAlertMsg(res.data.userloginresponse.rows.msg);
        setAlertType('error');
      }
      else {
        setShowAlert(true);
        setAlertMsg('Successfully Logged In');
        setAlertType('success');

        let userDetails = res.data.userloginresponse.rows[0];
        console.log(userDetails.user_profile);
        let token = res.data.userloginresponse.token;
        userData.setState({
          userId: userDetails._id,
          name: userDetails.user_full_name,
          username: userDetails.user_name,
          email: userDetails.user_email,
          mobile: userDetails.user_mobile,
          profile: userDetails.user_profile[0].profile_name,
          token: token,
          isLogin: true
        });
        // navigate('/summary', { replace: true });
          window.location.href = '/home';
      }
    }
    else {
      setShowAlert(true);
      setAlertMsg('Wrong Credentials');
      setAlertType('error');
      // 1t631s65
      //AppUtils.ShowMsg(pnkstore.error.prettyMessage)
    }

    setLogin(false);
  }

  return (
    <Box>
      <LoginComp
        state={state}
        login={login}
        SignIn={SignIn}
        HandleInputs={HandleInputs}
        handleCloseAlert={handleCloseAlert}
      />
      {console.log(loginData)}
      {((login === true) ? LoginUser(pnkstore, loginData, Handleuserloginresponseonse) : "")}
    </Box>
  );
}


export default Login;